import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ConfigurationProductFamiliesView } from "src/components/views/erp/configurator/managing/productFamilies/ConfigurationProductFamiliesView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/configurator/productFamilies")({
	staticData: { title: i18n.t("product_families"), legacyViewKey: "configurationProductFamiliesView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ConfigurationProductFamiliesView />;
}
